import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f9f4b60&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6f9f4b60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f4b60",
  null
  
)

/* custom blocks */
import block0 from "~/lang/humanising/insurance?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231201105121%2Fpages%2Fcompare-life-insurance%2Findex.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./index.vue?vue&type=custom&index=1&blockType=router"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsInsuranceLifeInsuranceCapturePoint: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/insurance/life-insurance/capture-point.vue').default,ProductsHumanising: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/humanising.vue').default,ProductsMoreInfo: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/more-info.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/site/feefo.vue').default})
